import styles from '../Actions.module.css';
import { Button, ButtonGroup } from '@blueprintjs/core';

export type IConfirmAction = {
  handleConfirmAction: () => void;
  handleCancelAction: () => void;
  confirmationText: string;
};

export function ConfirmAction({
  handleConfirmAction,
  handleCancelAction,
  confirmationText,
}: IConfirmAction) {
  return (
    <div className={styles.buttonContainer}>
      {confirmationText}
      <ButtonGroup>
        <Button small minimal icon="cross" onClick={handleCancelAction}>
          No
        </Button>
        <Button small minimal icon="tick" onClick={handleConfirmAction}>
          Yes
        </Button>
      </ButtonGroup>
    </div>
  );
}
